import { Howl } from 'howler';
import exclamationMark from '../sound/exclamation-mark.mp3';
import questionMark from '../sound/question-mark.mp3';

const sounds = {
  exclamationMark: new Howl({
    src: [exclamationMark],
  }),

  questionMark: new Howl({
    src: [questionMark],
  }),
};

function playSound(soundName) {
  sounds[soundName].play();
}

export default playSound;



// WEBPACK FOOTER //
// ./src/js/sound.js